import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, stagger, item } from "@/lib/motion";
import { WHY_US } from "@/data/site";

const ABOUT_IMG = "https://images.unsplash.com/photo-1681949103006-70066fb25dfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwY3JlYXRpdmUlMjB0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3ODYxNzE4Nzd8MA&ixlib=rb-4.1.0&q=85";

export const WhyChoose = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal className="relative">
            <div className="overflow-hidden rounded-3xl border border-border shadow-sm">
              <img
                src={ABOUT_IMG}
                alt="RedKey Digital team collaborating on a project"
                loading="lazy"
                className="w-full h-[420px] md:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:right-8 rounded-2xl border border-border bg-card px-6 py-4 shadow-lg">
              <p className="text-3xl font-heading font-extrabold text-primary">1–3 wks</p>
              <p className="text-xs text-muted-foreground">Typical launch time</p>
            </div>
          </Reveal>

          <div>
            <Reveal as="p" className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Why Choose Us</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 text-4xl md:text-5xl font-heading font-bold tracking-tight leading-tight">
                Built for speed, designed to convert
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-4 text-muted-foreground text-lg">
              We combine world-class design, clean engineering and practical AI to give your business a genuine edge online — without the agency bloat or endless delays.
            </Reveal>

            <motion.ul
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-5"
            >
              {WHY_US.map((w) => (
                <motion.li key={w.title} variants={item} className="flex gap-3">
                  <span className="grid place-items-center w-6 h-6 rounded-full bg-primary/15 text-primary shrink-0 mt-0.5">
                    <Check className="w-3.5 h-3.5" />
                  </span>
                  <div>
                    <p className="font-semibold text-sm">{w.title}</p>
                    <p className="text-sm text-muted-foreground mt-0.5">{w.desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  );
};
